import keys from './ro.json';

function relativeTimeWithPlural(number, withoutSuffix, key) {
  var format = {
      ss: 'secunde',
      mm: 'minute',
      hh: 'ore',
      dd: 'zile',
      ww: 'săptămâni',
      MM: 'luni',
      yy: 'ani',
    },
    separator = ' ';
  if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
    separator = ' de ';
  }
  return number + separator + format[key];
}

export default {
  locale: 'ro',
  messages: {
    ...keys,
    'RoundDateDisplay::format': `{ hasEnd, select,
      true {
        { preposition, select,
          at { la ora { end } }
          until { până la ora { end } }
        }
      }
      other { { duration, plural,
          one { # zi }
          other { # zile }
        }
      }
    }`,
    statusvalue: `{ roundNumber, select,
      0 {
        { content, select,
          Preview { previzualizare }
          Resolved { Încheiat }
          other { {content} }
        }
      }
      other {
        { roundType, select,
          sealed_bidding { Inchisă }
          open_bidding { Deschisă }
          counteroffer_bidding { Contra oferta }
          registration { Înregistrare }
          SealedBidding { Inchisă }
          OpenBidding { Deschisă }
          CounterofferBidding { Contra oferta }
        }
        round
        { roundNumber }
        { roundStatus, select,
          opened { deschis }
          started { a început }
          closed { închis }
          other { {roundStatus} }
        }
      }
    }`,
    'RoundInfo::label': `
      { type, select,
        sealed_bidding { Închisă }
        open_bidding { Deschisă }
        incremental_auction { Flexibilă }
        counteroffer_bidding { Contraofertă }
        registration { Înregistrare }
        simple_offer { Ofertă de cumpărare digitală }
      }
      rundă
      { number }
      { status, select,
        started { nu a fost încă deschisă }
        opened
        {
          { hasEnd, select,
            true {
              { durationType, select,
                  fixed {
                    { isPreview, select,
                      true { începe {startDuration} }
                      false {
                        { isPast, select,
                          false { peste {endDuration} }
                          other { a trecut }
                        }
                      }
                    }
                  }
                  flexible { peste {durationInDays} zile }
              }
            }
            other {  }
          }
        }
        closed { închisă la { endText } }
        other { {status} }
      }
    `,
  },

  moment: {
    months:
      'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
        '_'
      ),
    monthsShort:
      'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat: {
      LT: 'H:mm',
      LTS: 'H:mm:ss',
      L: 'DD.MM.YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY H:mm',
      LLLL: 'dddd, D MMMM YYYY H:mm',
    },
    calendar: {
      sameDay: '[azi la] LT',
      nextDay: '[mâine la] LT',
      nextWeek: 'dddd [la] LT',
      lastDay: '[ieri la] LT',
      lastWeek: '[fosta] dddd [la] LT',
      sameElse: 'L',
    },
    relativeTime: {
      future: 'peste %s',
      past: '%s în urmă',
      s: 'câteva secunde',
      ss: relativeTimeWithPlural,
      m: 'un minut',
      mm: relativeTimeWithPlural,
      h: 'o oră',
      hh: relativeTimeWithPlural,
      d: 'o zi',
      dd: relativeTimeWithPlural,
      w: 'o săptămână',
      ww: relativeTimeWithPlural,
      M: 'o lună',
      MM: relativeTimeWithPlural,
      y: 'un an',
      yy: relativeTimeWithPlural,
    },
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 7, // The week that contains Jan 7th is the first week of the year.
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/ro.js